import { locationIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const getProductInventory = {
  name: "getProductInventory" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
  }),
  output: z.object({
    quantity: z.bigint(),
    committed: z.bigint(),
    reserved: z.bigint(),
    available: z.bigint(),
  }),
};
